import React from 'react';

const personas = [
  {
    name: 'Bernard',
    role: 'Le networker actif',
    quote: '“Je rencontre 50 personnes par mois, KORA m’aide à ne rien oublier”',
    color: 'bg-pink-50',
    img: 'https://randomuser.me/api/portraits/men/32.jpg',
  },
  {
    name: 'Julie',
    role: 'La manager relationnelle',
    quote: '“KORA structure mes relations équipe et partenaires efficacement”',
    color: 'bg-blue-50',
    img: 'https://randomuser.me/api/portraits/women/44.jpg',
  },
  {
    name: 'Demba',
    role: 'L’étudiant connecté',
    quote: '“Parfait pour développer mon réseau professionnel dès mes études”',
    color: 'bg-green-50',
    img: 'https://randomuser.me/api/portraits/men/45.jpg',
  },
  {
    name: 'Fatou',
    role: 'La connectrice naturelle',
    quote: '“KORA amplifie mon talent naturel pour connecter les gens”',
    color: 'bg-purple-50',
    img: 'https://randomuser.me/api/portraits/women/65.jpg',
  },
];

function Personas() {
  return (
    <section className="bg-white py-20 px-4 md:px-0" id="personas">
      <h2 className="text-3xl font-bold text-blue-900 text-center mb-2">Pour qui ?</h2>
      <p className="text-center text-blue-700 max-w-2xl mx-auto mb-10">KORA s’adapte à tous les profils relationnels</p>
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
        {personas.map((p) => (
          <div key={p.name} className={`rounded-2xl ${p.color} p-6 flex flex-col items-center shadow-sm transition-transform duration-300 hover:scale-105 hover:shadow-xl animate-fadeIn`}>
            <img src={p.img} alt={p.name} className="w-20 h-20 rounded-full object-cover border-4 border-white shadow mb-3" />
            <h3 className="font-semibold text-blue-900 mb-1">{p.name}</h3>
            <div className="text-blue-700 text-sm mb-2 text-center">{p.role}</div>
            <p className="italic text-blue-800 text-center text-sm">{p.quote}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Personas; 